import React from "react";

const SuggestionButton = () => {
  return (
    <a
      href="mailto:administracion@ssfiltraciones.mx?subject=Buzón de sugerencias y denuncias"
      className="suggestion-button"
    >
      <svg
        className="suggestion-icon"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        <path d="M13 8h.01" />
        <path d="M9 8h.01" />
        <path d="M17 8h.01" />
      </svg>

      <div className="suggestion-content">
        <span className="text">Buzón de sugerencias y denuncias</span>
        <small>Confidencial</small>
      </div>
    </a>
  );
};

export default SuggestionButton;